<template>
    <div :class="pageClass">
        <div :class="[`${pageClass}-header`]">
            <Header></Header>
        </div>
        <div :class="[`${pageClass}-main`]">
            <div :class="[`${pageClass}-main-content`]">
                <div :class="[`${pageClass}-main-content-box`]">
                    <div :class="[`${pageClass}-main-content-box-nav`]">
                        
                        <p class="name">精讲资源列表</p>
                        <div :class="[`${pageClass}-main-content-box-nav-list`]">
                            <el-menu
                                v-if="resourceList.length"
                                router 
                                text-color="#5c307d"
                                active-text-color="#ffffff"
                                :default-active="$route.path"
                                class="el-menu-vertical-demo"
                            >
                                <!-- <el-menu-item v-for="(resource, index) in resourceList">
                                    <img src="filterUrl(resource.path)" alt="">
                                    <span slot="title">filterName(resource.title).pdf</span>
                                </el-menu-item> -->
                            </el-menu>
                            <p v-else class="no_content">暂无数据</p>
                        </div>

                    </div>
                    <div :class="[`${pageClass}-main-content-box-right`]">
                        <!-- <div v-if="showState" class="videobox">
                            <video :src="videoUrl" ></video>
                        </div>
                        <div v-else style="height: 100%; width: 100%" class="videobox">
                            <iframe id="show-iframe" width="100%" height="100%"  frameborder=0 name="showHere" scrolling=auto src="https://www.baidu.com/"></iframe>
                        </div> -->
                        <div class="videobox">
                            <video :src="videoUrl" ></video>
                        </div>
                        <p class="no_content">暂无数据</p>
                    </div>
                </div>
            </div>
        </div>
        <div :class="[`${pageClass}-footer`]">
            <Footer></Footer>
        </div>
    </div> 
</template>

<script>
import Header from '@/components/header/header'
import Footer from '@/components/footer/footer'

export default {
    name : 'layout',
    data() {
        return {
            pageClass: 'layout',
            qid: null,
            showState: false,// 展示形式
            resourceList: [],
            videoUrl: '',
            iframeUrl: ''
        }
    },
    components:{
        Header,
        Footer
    },
    created() {
        this.qid = this.$route.query.qid
        this.getResourceInfo()
    },
    methods: {
        getResourceInfo() {
            this.$HTTP.executePost(this.$APIS.GET_GK_RESOURCE, { questionId: this.qid }, this).then(res => {
                let code = res.code;
                if (!code) {
                    this.resourceList = res.data
                } else {
                    this.$message.error(res.msg);
                }
            })  
        },
        selectRecource(data) {
            let photoExt = data.path.substr(data.path.lastIndexOf(".")).toLowerCase();//获得文件后缀名
            if (photoExt == 'mp4') {
                this.showState = true
                this.videoUrl = ''
            } else {
                this.iframeUrl
            }
        },
        filterUrl(url) {
            //获取最后一个.的位置
            var index= url.lastIndexOf(".");
            //获取后缀
            // var ext = filePath.substr(index + 1);

            // switch (ext) {
            //     case 'mp4':
                    
            //         break;
            
            //     default:
            //         break;
            // }
        },
        // filterName(name) {

        // }
    }
}
</script>

<style lang="stylus" scoped>
    html, body {
        height:100%;
        margin:0;
        padding:0;
        overflow:hidden
    }
    .layout {
        height:100%;
        &-header {
            height: 72px;
            width:100%;
            position:absolute;
            z-index:5;
            top:0;
        }
        &-main {
            width:100%;
            overflow:auto;
            top: 72px;
            position: absolute;
            z-index: 10;
            bottom: 43px;
            background-color: #efefef;
            &-content {
                width: 1520px;
                height: 100%;
                margin: 0 auto;
                position: relative;
                &-box {
                    position: absolute;
                    top: 20px;
                    bottom: 20px;
                    left: 0;
                    right: 0;
                    z-index: 20;
                    display: flex;
                    &-nav {
                        width: 300px;
                        height: 100%;
                        background-color: #ffffff;
                        
                        &-user {
                            width: 200px;
                            height: 200px;
                            border-radius: 100px;
                            overflow: hidden;
                            margin-top: 60px;
                            margin-left: 50px;
                            img {
                            width: 200px;
                            height: 200px;
                            }
                        }
                        &-list {
                            width: 100%;
                            margin-top: 30px;

                            /deep/ .el-menu-item {
                                // left: 0px;
                                // padding-left: 50px !important;
                                width: 80%;
                                left: 10%;
                                font-size 18px;
                                height 100px;
                                border: 1px solid #cb86ff;
                                margin-bottom: 20px;
                                img {
                                    margin-top: 5px;
                                }
                                span { 
                                    font-size: 27px;
                                    color: #ac75d5;
                                    margin-left: 40px;
                                }
                            }

                            /deep/ .is-active {
                                background-color: #5c307d;
                                color: #ffffff;
                            }

                            .no_content {
                                width: 100%;
                                text-align: center;
                                margin-top: 100px;
                            }
                        }
                        .name {
                            width: 100%;
                            height: 50px;
                            line-height: 50px;
                            text-align: center;
                            color: #585858;
                            margin: 0 auto;
                            font-size: 19px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            background-color: #5c307d;
                            color: #fff;
                        }
                    }
                    &-right {
                        margin-left: 27px;
                        flex: 1;
                        background-color: #ffffff;
                        position: relative;

                        .videobox {
                            width: 100%;
                            height: 100px;
                        }
                        .no_content {
                            width: 100%;
                            text-align: center;
                            margin-top: 100px;
                        }
                    }
                }
            }
        }
        &-footer {
            height:43px;
            width:100%;
            position:absolute;
            z-index:200;
            bottom:0;
        }
    }
</style>